import Splide from '@splidejs/splide';
import Header from './modules/Header';
import Search from "./modules/Search";
import ContactForm7 from "./modules/ContactForm7";
import ProductSlider from "./modules/ProductSlider";
import SocialLogin from "./modules/SocialLogin";
import ProductArchive from "./modules/ProductArchive";
import ProductCard from "./modules/ProductCard";
import ProductPage from "./modules/ProductPage";
import Checkout from "./modules/Checkout";
import ProductATCBar from "./modules/ProductATCBar";
import {
    closeMiniCart,
    headerCartOpen,
    headerCartContinue,
    miniCartQtyChange,
    initMiniCartCloseOutside
} from './modules/MiniCart';
import Blog from "./modules/Blog";
import ResizeSwatchThumbs from "./modules/ResizeSwatchThumbs";


/* Import all required blocks */
import BlockHeroSlider from "../../includes/blocks/block-hero-slider/script";
import BlockIconsSlider from "../../includes/blocks/block-icons/script";
import BlockTextLoopSlider from "../../includes/blocks/block-text-loop/script";
import BlockTextSlider from "../../includes/blocks/block-text-slider/script";
import BlockProductGallery from "../../includes/blocks/block-product-gallery/script";
import BibliographyToggle from "../../includes/blocks/block-bibliography/script";
import BlockSlidersGallery from "../../includes/blocks/block-sliders-gallery/script";
import BlockFaq from "../../includes/blocks/block-faq/script";
import {fireNotification} from "./modules/Notifications";

/* Import all required modules */
window.splide = Splide;
window.lightbox = require('simple-lightbox');
window.themeNotifications = fireNotification;

/* Initialize modules */
Header();
Search();
ProductSlider();
ContactForm7();
ProductArchive();
ProductCard();
ProductPage();
Checkout();
ProductATCBar();
closeMiniCart();
initMiniCartCloseOutside();
headerCartOpen();
headerCartContinue();
miniCartQtyChange();
Blog();
ResizeSwatchThumbs();

/* Initialize blocks */
BlockHeroSlider();
BlockIconsSlider();
BlockTextLoopSlider();
BlockTextSlider();
SocialLogin();
BlockProductGallery();
BibliographyToggle();
BlockSlidersGallery();
BlockFaq();
